import { useMemo } from 'react';
import { useIssuerPortfolioPnlOvertimeChartByIdQuery } from '@/modules/issuer-dashboard/queries/portfolios.tsx';
import { ChartBarData, ChartBarWithPositiveNegative, ChartEmptyState, InfoCard, Spinner } from 'ui';

interface ChartPnlOverTimeProps {
  portfolioId: number;
}

export const ChartPnlOverTime = ({ portfolioId }: ChartPnlOverTimeProps) => {
  const {
    isFetching,
    isLoading,
    isError,
    data: dataPnlOvertimeChart,
  } = useIssuerPortfolioPnlOvertimeChartByIdQuery({
    portfolio_id: portfolioId,
  });

  const chartData = useMemo<ChartBarData[]>(() => {
    if (!dataPnlOvertimeChart?.data?.length) return [];

    const items = dataPnlOvertimeChart?.data?.map<ChartBarData>(item => ({
      value: item.value,
      date: item.date,
    }));

    return items;
  }, [dataPnlOvertimeChart?.data]);

  return (
    <InfoCard
      title="PNL over time"
      classes={{ content: 'w-full p-0 px-6 pt-4' }}
      headerAction={
        <div className="flex items-center justify-end gap-2">
          {isFetching && !isLoading && <Spinner size="md" />}
        </div>
      }
    >
      <div className="flex flex-col gap-4">
        {!chartData?.length && (
          <div className="py-4 flex justify-center items-center font-medium text-lg">
            <ChartEmptyState isError={isError} isLoading={isLoading} />
          </div>
        )}
        {!isLoading && chartData?.length > 0 && (
          <ChartBarWithPositiveNegative height="370" data={chartData} description="PNL Percent" />
        )}
      </div>
    </InfoCard>
  );
};
